import { Mouvement } from '@mairistem/comptabilite';
import type { UserRole } from '@mairistem/finances-utils';
import type BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';

abstract class BaseBordereauState {
  state: BordereauStateType;

  color: string;

  libelle: string;

  step: number;

  abstract getBordereauActions(
    _bordereau: BordereauWithState,
    _userRole: UserRole
  ): BaseLiquidationAction<BordereauWithState, BordereauActionType>[];

  abstract getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[];
}

export default BaseBordereauState;
